import React, { useState } from 'react';
import { Checkbox } from '@nazka/nazka.mapframe.components';
import { useTranslation } from '@utils/i18n/i18n.consumers';

import './checklist-template.styl';

function ChecklistTemplate({ selectedPart }) {
  const { t } = useTranslation()
  const [checked, setChecked] = useState([])
  return (
    <div className="checklist-template">
      <h3>{t(`${selectedPart.title}`)}</h3>
      {selectedPart.subtitle && <h4 className="explanation-template__subtitle" style={{ margin: '0px' }}>{t(`${selectedPart.subtitle}`)}</h4>}
      {selectedPart.description && <p style={{ margin: '0px' }}>{t(`${selectedPart.description}`)}</p>}
      <div className="checklist-template__content">
        {selectedPart.subparts.map(subpart => (
          <div key={subpart.id} className="checklist-template__content-item">
            {subpart.icon && <img className="checklist-template__content-item__icon" src={subpart.icon} alt={subpart.title} />}
            <div>
              <Checkbox
                key={subpart.id}
                text={t(`${subpart.title}`)}
                css={{
                  fontSize: '18px',
                  fontWeight: 'bold',
                }}
                checked={checked.includes(subpart.title)}
                iconProps={{ size: '24px' }}
                className="checklist-template__content-item__checkbox"
                onInputChange={() => {
                  if (checked.includes(subpart.title)) {
                    setChecked(prev => prev.filter(id => id !== subpart.title))
                  } else {
                    setChecked(prev => [...prev, subpart.title])
                  }
                }}
              />
              {subpart.subtitle && <p className="checklist-template__content-item__subtitle">{t(`${subpart.subtitle}`)}</p>}
              <ul>
                {subpart.description && subpart.description.map(item => (
                  <li key={item}>{t(`${item}`)}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>  
  );
}

export default ChecklistTemplate;